/* ===========================================================
   KESHAR — global.js
   Sticky header · mobile nav · AJAX cart drawer · reveals
   =========================================================== */
(function () {
  'use strict';

  var root = document.documentElement;
  var body = document.body;

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* ---------- Sticky header shadow ---------- */
  var header = $('.site-header');
  function onScroll() {
    if (!header) return;
    header.classList.toggle('is-scrolled', window.scrollY > 8);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- Overlay + panels ---------- */
  var overlay = $('[data-overlay]');
  function openPanel(el) {
    if (!el) return;
    el.classList.add('is-open');
    el.removeAttribute('hidden');
    if (overlay) { overlay.removeAttribute('hidden'); requestAnimationFrame(function(){ overlay.classList.add('is-active'); }); }
    body.classList.add('no-scroll');
  }
  function closeAllPanels() {
    $$('.cart-drawer.is-open, .mobile-nav.is-open').forEach(function (el) { el.classList.remove('is-open'); });
    if (overlay) {
      overlay.classList.remove('is-active');
      setTimeout(function () { overlay.setAttribute('hidden', ''); }, 380);
    }
    body.classList.remove('no-scroll');
  }
  if (overlay) overlay.addEventListener('click', closeAllPanels);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAllPanels(); });

  /* ---------- Mobile nav ---------- */
  var mobileNav = $('.mobile-nav');
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-nav-open]')) { e.preventDefault(); openPanel(mobileNav); }
    if (e.target.closest('[data-nav-close]')) { e.preventDefault(); closeAllPanels(); }
  });

  /* ---------- Cart drawer ---------- */
  var drawer = $('[data-cart-drawer]');

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (count > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
  }

  function renderDrawerFromSection(html) {
    if (!drawer || !html) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var fresh = parsed.querySelector('[data-cart-contents]');
    var live = drawer.querySelector('[data-cart-contents]');
    if (fresh && live) live.innerHTML = fresh.innerHTML;
    var countEl = parsed.querySelector('[data-cart-total-count]');
    if (countEl) updateCartCount(parseInt(countEl.textContent, 10) || 0);
  }

  function postCart(url, payload) {
    payload.sections = ['cart-drawer'];
    payload.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json(); });
  }

  function addToCart(id, qty, btn) {
    if (btn) btn.classList.add('is-loading');
    postCart('/cart/add.js', { items: [{ id: id, quantity: qty || 1 }] })
      .then(function (data) {
        if (data && data.sections && data.sections['cart-drawer']) {
          renderDrawerFromSection(data.sections['cart-drawer']);
        }
        openPanel(drawer);
      })
      .catch(function () { window.location.href = '/cart'; })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  }

  function changeLine(line, qty) {
    postCart('/cart/change.js', { line: line, quantity: qty })
      .then(function (data) {
        if (data && data.sections && data.sections['cart-drawer']) {
          renderDrawerFromSection(data.sections['cart-drawer']);
        } else { window.location.reload(); }
      });
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-cart-open]');
    if (openBtn) { e.preventDefault(); openPanel(drawer); return; }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeAllPanels(); return; }

    var add = e.target.closest('.add-to-cart[data-variant-id]');
    if (add) {
      e.preventDefault();
      var id = add.getAttribute('data-variant-id');
      var q = parseInt(add.getAttribute('data-quantity'), 10) || 1;
      if (id && id !== '') addToCart(id, q, add);
      return;
    }

    var remove = e.target.closest('[data-line-remove]');
    if (remove) { e.preventDefault(); changeLine(parseInt(remove.getAttribute('data-line'), 10), 0); return; }

    var step = e.target.closest('[data-line-step]');
    if (step) {
      e.preventDefault();
      var lineIdx = parseInt(step.getAttribute('data-line'), 10);
      var dir = parseInt(step.getAttribute('data-line-step'), 10);
      var input = step.parentNode.querySelector('input');
      var current = input ? (parseInt(input.value, 10) || 1) : 1;
      var next = Math.max(0, current + dir);
      changeLine(lineIdx, next);
      return;
    }
  });

  /* Plain quantity steppers (e.g. product page, not cart) */
  document.addEventListener('click', function (e) {
    var qstep = e.target.closest('[data-qty-step]');
    if (!qstep) return;
    e.preventDefault();
    var wrap = qstep.closest('.qty');
    if (!wrap) return;
    var input = wrap.querySelector('input');
    var dir = parseInt(qstep.getAttribute('data-qty-step'), 10);
    var v = Math.max(1, (parseInt(input.value, 10) || 1) + dir);
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product page: variant switching ---------- */
  $$('[data-product-form]').forEach(function (form) {
    var data;
    try { data = JSON.parse(form.querySelector('[data-variants-json]').textContent); } catch (err) { return; }
    var radios = $$('input[data-variant-option]', form);
    var addBtn = form.querySelector('.add-to-cart');
    var priceEl = $('[data-product-price]');
    var qtyInput = form.querySelector('.qty input');

    function selectedOptions() {
      var opts = {};
      radios.forEach(function (r) { if (r.checked) opts[r.getAttribute('data-option-index')] = r.value; });
      return opts;
    }
    function matchVariant() {
      var opts = selectedOptions();
      return data.find(function (v) {
        return Object.keys(opts).every(function (k) { return v.options[k] === opts[k]; });
      });
    }
    function refresh() {
      var v = matchVariant() || data[0];
      if (!v) return;
      if (addBtn) {
        addBtn.setAttribute('data-variant-id', v.available ? v.id : '');
        addBtn.textContent = v.available ? 'Add to basket' : 'Sold out';
        addBtn.disabled = !v.available;
      }
      if (priceEl && v.price_html) priceEl.innerHTML = v.price_html;
    }
    radios.forEach(function (r) { r.addEventListener('change', refresh); });
    if (qtyInput && addBtn) {
      function syncQty() { addBtn.setAttribute('data-quantity', Math.max(1, parseInt(qtyInput.value, 10) || 1)); }
      qtyInput.addEventListener('change', syncQty); syncQty();
    }
    refresh();
  });

  /* ---------- Product gallery thumbs ---------- */
  $$('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-gallery-main] img');
    $$('[data-gallery-thumb]', g).forEach(function (t) {
      t.addEventListener('click', function () {
        if (main) { main.src = t.getAttribute('data-full'); main.alt = t.querySelector('img').alt; }
        $$('[data-gallery-thumb]', g).forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  });

  /* ---------- Scroll reveals ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    $$('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  }
})();
